'use strict';

var _ = require('lodash');
var ConfigurationParametersRenderersFactory = function ConfigurationParametersRenderersFactory(configurationParametersControlTypeService) {
  /**
   * Translates "00/00/70" format from masked input into "0d 0h 70m" format saved to db and displayed to user after editing
   * @param value
   * @returns {string}
   */
  function parseMaskTimeValue(value) {
    if (!value.match(/d|h|m/g)) {
      var parsedValue = value.replace(/00/g, '0').replace(/_/g, '0').replace(/0(\d)/g, '$1').split('/');
      return parsedValue[0] + 'd ' + parsedValue[1] + 'h ' + parsedValue[2] + 'm';
    }
    return value;
  }

  /**
   * Translates "0d 0h 70m" format from db and displayed to the user into "00/00/70" format needed for masked input
   * @param value
   * @returns {string}
   */
  function maskTimeValue(value) {
    // add leading zeros
    value = value.replace(/^([0-9]d)/g, '0$1').replace(/\s([0-9]{1}h)\s/g, ' 0$1 ').replace(/\s([0-9]{1}m)/, ' 0$1');
    // remove letters add slashes
    return value.replace(/d|h|m/g, '').replace(/\s/g, '/');
  }

  /**
   * Returns rendered cell with value parsed from 00/00/70 masked editable format into '0d 0h 70m' displayed format
   * @param columnContext
   * @param rowIndex
   * @param columnfield
   * @param value
   * @param defaultvalue
   * @param column
   * @param row
   * @returns {string}
   */
  var cellsSpecificView = function cellsSpecificView(columnContext, rowIndex, columnfield, value, defaultvalue, column, row) {
    if (configurationParametersControlTypeService.isControlTypeMaskedInput(row.propertyName) && value.indexOf('/') > -1) {
      var parsedValue = parseMaskTimeValue(value);
      return defaultvalue.replace('>' + value + '<', '>' + parsedValue + '<');
    } else if (row.propertyType === 'number') {
      return defaultvalue.replace('>' + value + '<', '>' + value + '<');
    }
    return defaultvalue;
  };
  function formatPercentValue(value) {
    return value * 100;
  }
  function parsePercentValue(value) {
    return value / 100;
  }
  function formatLevelValue(value) {
    var levels = configurationParametersControlTypeService.getStrategyDomainLevels();
    return levels[value];
  }
  function parseLevelValue(value) {
    var levels = configurationParametersControlTypeService.getStrategyDomainLevels();
    return _.invert(levels)[value];
  }
  function formatValue(key, value) {
    if (configurationParametersControlTypeService.isPercentProperty(key)) {
      return formatPercentValue(value);
    } else if (configurationParametersControlTypeService.isLevelProperty(key)) {
      return formatLevelValue(value);
    } else {
      return value;
    }
  }
  function parseValue(key, value) {
    if (configurationParametersControlTypeService.isPercentProperty(key)) {
      return parsePercentValue(value);
    } else if (configurationParametersControlTypeService.isLevelProperty(key)) {
      return parseLevelValue(value);
    } else {
      return value;
    }
  }
  return {
    cellsSpecificView: cellsSpecificView,
    parseMaskTimeValue: parseMaskTimeValue,
    maskTimeValue: maskTimeValue,
    formatValue: formatValue,
    parseValue: parseValue
  };
};
ConfigurationParametersRenderersFactory.$inject = ['ConfigurationParametersControlTypeService'];
module.exports = ConfigurationParametersRenderersFactory;